import { createSelector } from '@reduxjs/toolkit';
import { selectPromoSearchTypes as selectAllPromoSearchTypes } from 'shared/selectors/jsonQuery';
import { selectPromoSearchTypes } from 'shared/selectors/promoSearchTypes';
import { getPromoSearchFilterValuesByType } from 'shared/utils/promoSearchTypes';

export const selectDiscountPromoSearchTypeValue = createSelector(
  [selectAllPromoSearchTypes, selectPromoSearchTypes],
  (allValues, promoSearchTypes) => {
    if (!allValues || !promoSearchTypes) {
      return [null];
    }

    const availableFilterValues = getPromoSearchFilterValuesByType('discount', promoSearchTypes);
    const filteredValues = allValues.filter(value => availableFilterValues.includes(value));

    return filteredValues.length ? filteredValues : [null];
  },
);
